/**
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Icon, ICON_SIZE } from "../../../../ui/components/Icon";

export const MdxBadge: React.FC<Record<string, unknown>> = (props) => {
	const className = BEM("edt-documentation-mdx-badge", undefined, {
		"has-icon": !!props.icon
	});

	return (
		<span
			className={className.toClassName()}
		>
			{props.icon && (
				<Icon name={props.icon as string} size={ICON_SIZE.XSMALL} />
			)}
			{props.children}
		</span>
	)
};
